{
    "NextrunningatLabel": "Prossima corsa a:",
    "LastrunatLabel": "Ultima corsa a:",
    "StatuserrorLabel": "Stato \/ Errore:",
    "ScheduleStatus_SectionHeader": "Stato della programmazione",
    "NAME": "ScheduleStatus"
}